/**
 * Geometría del isotipo de Mixcore (versión final, sep-2026), viewBox
 * `0 0 100 100` con centro en (50, 50). Es la misma de la web
 * (mixcore-web: src/Componentes/Brand/brandMark.js); si cambia allá, cambia acá.
 *
 *  - POSITIVE: marca oscura sobre fondo claro.
 *  - REVERSED: marca crema sobre negro (ícono de app): anillo más fino y punto
 *    más chico, la compensación óptica de los originales.
 *
 * `d` = los dos arcos del anillo + las dos barras; el punto va aparte.
 */
export const MARK_POSITIVE = {
  d: "M88.25 41.05L92.93 41.05A1.6 1.6 0 0 0 94.49 39.07A45.81 45.81 0 0 0 5.51 39.07A1.6 1.6 0 0 0 7.07 41.05L11.75 41.05A1.6 1.6 0 0 0 13.29 39.88A38.08 38.08 0 0 1 86.71 39.88A1.6 1.6 0 0 0 88.25 41.05ZM88.25 58.95L92.93 58.95A1.6 1.6 0 0 1 94.49 60.93A45.81 45.81 0 0 1 5.51 60.93A1.6 1.6 0 0 1 7.07 58.95L11.75 58.95A1.6 1.6 0 0 1 13.29 60.12A38.08 38.08 0 0 0 86.71 60.12A1.6 1.6 0 0 1 88.25 58.95ZM2.73 46.13H18.9A2.5 2.5 0 0 1 21.4 48.63V51.36A2.5 2.5 0 0 1 18.9 53.86H2.73A2.5 2.5 0 0 1 0.23 51.36V48.63A2.5 2.5 0 0 1 2.73 46.13ZM81.1 46.13H97.27A2.5 2.5 0 0 1 99.77 48.63V51.36A2.5 2.5 0 0 1 97.27 53.86H81.1A2.5 2.5 0 0 1 78.6 51.36V48.63A2.5 2.5 0 0 1 81.1 46.13Z",
  dotR: 14.12,
};

export const MARK_REVERSED = {
  d: "M89.04 40.84L93.39 40.84A1.2 1.2 0 0 0 94.56 39.36A45.81 45.81 0 0 0 5.44 39.36A1.2 1.2 0 0 0 6.61 40.84L10.96 40.84A1.2 1.2 0 0 0 12.12 39.95A39.19 39.19 0 0 1 87.88 39.95A1.2 1.2 0 0 0 89.04 40.84ZM89.04 59.16L93.39 59.16A1.2 1.2 0 0 1 94.56 60.64A45.81 45.81 0 0 1 5.44 60.64A1.2 1.2 0 0 1 6.61 59.16L10.96 59.16A1.2 1.2 0 0 1 12.12 60.05A39.19 39.19 0 0 0 87.88 60.05A1.2 1.2 0 0 1 89.04 59.16ZM1.53 46.5H18.14A1.3 1.3 0 0 1 19.44 47.8V52.2A1.3 1.3 0 0 1 18.14 53.5H1.53A1.3 1.3 0 0 1 0.23 52.2V47.8A1.3 1.3 0 0 1 1.53 46.5ZM81.86 46.5H98.47A1.3 1.3 0 0 1 99.77 47.8V52.2A1.3 1.3 0 0 1 98.47 53.5H81.86A1.3 1.3 0 0 1 80.56 52.2V47.8A1.3 1.3 0 0 1 81.86 46.5Z",
  dotR: 12.83,
};

/** Dentro del ícono de app la marca ocupa el 65.7% del ancho. */
export const TILE_SCALE = 0.657;
export const TILE_RADIUS = 22.5;
/** Centra la marca en el cuadrado del ícono (50 − 50 × TILE_SCALE = 17.15). */
export const TILE_TRANSFORM = "translate(17.15 17.15) scale(0.657)";
